// Eponyms product wants kept as-is; everything else lowercases in a sentence.
const KEEP_CASE = ['Graves', 'Alzheimer', 'Parkinson'];

export default function formatConditionName(
  conditionName: string = 'this condition',
): string {
  if (KEEP_CASE.some(name => conditionName.startsWith(name))) {
    return conditionName;
  }

  return conditionName
    .split(' ')
    .map(word => (/[A-Z]{2,}/.test(word) ? word : word.toLowerCase()))
    .join(' ');
}
